export const PROTOCOL_HTTP = "http";
export const HOST_API = "https://api.carnessantacruz.co";
export const PATH_S3_BUCKET = "https://carnessantacruz-static.s3.amazonaws.com";
export const DEFAULT_AVATAR_IMAGE = "../../../public/avatar.png";

export const BUCKET = "carnessantacruz-static";
